export default __webpack_public_path__ + "static/media/cavemenClashingMobile.3af27978.png";